module.exports = __webpack_public_path__ + "static/media/errorCat.18b4efd2.svg";